(function () {
  'use strict';

  angular
    .module('dashboard')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('dashboard', {
        url: '/dashboard',
        templateUrl: 'dashboard/dashboard.tpl.html',
        controller: 'DashboardCtrl',
        controllerAs: 'dashboard'
      })
      .state('dashboard.timeline', {
        url: '/dashboard-timeline',
        views: {
          '@': {
            templateUrl: 'dashboard/dashboard-timeline.tpl.html',
            controller: 'DashboardTimelineCtrl',
            controllerAs: 'dashboardTimeline'
          }
        }
      });
  }
}());
